import { Box, Card, Typography } from '@mui/material';
import LayoutAccessManagement from 'components/structure/LayoutAccessManagement';
import './RoleAssign.css';
import userLogo from 'assets/UserLogo.svg';
import React, { useState, useContext, useEffect } from 'react';
import CarouselMain from './RoleCarousel';
import { useNavigate } from 'react-router-dom';
import { AuthData } from "auth/AuthWarpper";
import { SnackbarContext } from "context/snackBarContext";
import LockedUser from 'components/structure/LockedUser'
import { el } from 'date-fns/locale';

const RoleAssignHome = () => {
  const navigate = useNavigate();
  const { user } = AuthData();
  const [carouselMenuVisible, setCarouselMenuVisible] = useState(true);
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  useEffect(() => {
    if (user?.profiles?.some(profile => profile.profileName === 'System Owner' || profile.profileName === 'ITCI PM')) {
        setCarouselMenuVisible(prevValue => false);
    }
  }, [])

 
const handleUserAccessNavigation = () => {
    if (user) {
        if(user?.profiles?.some(profile => profile.profileName === 'Administrator')){
            // navigate("/administratorCreation");
            navigate("/roleNavigation");
        }else if (user?.profiles?.some(profile => ["IT Admin Access Mgt", "SoX Report_Global User", "SoX Report_Local User"].some(role => 
            role.toLowerCase() === profile.profileName.toLowerCase()
        ))) {
            navigate("/roleNavigation");
        } 
        // always keep  this before else block
        else if (user?.profiles?.some(profile => profile.isRoleOwner === true) && !user?.profiles?.some(profile => 
            profile.profileName === 'IT Admin Access Mgt' || profile.profileName === 'Administrator'
        )) {
            navigate("/roleAssignList");
        }
        else {
            setSeverity("error");
            setMessage("Operation not allowed!");
            setOpenAlert(true);
        }
    } else {
        setSeverity("error");
        setMessage("Logged in user information not found!");
        setOpenAlert(true);
    }
};

console.log("user?.lockStatus" ,user?.lockStatus)

    return (
        <>
        {user && user?.lockStatus == true  && (<LockedUser />)}
     
        {((user && user?.lockStatus == false) || (user && user?.lockStatus == null))  && (
        <LayoutAccessManagement title="Access Management">
                <Card
                    className='Access-Management-Layout'
                    title="Card Title"
                    content="This is some content inside the card. You can customize it."
                    buttonText="Click Me"
                    sx={{
                        backgroundColor: "#f3f5f8",
                        color: "white",
                        marginBottom: "0px !important",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Box sx={{ width: "100%", paddingTop: "40px", gap: 4, display: "flex", flexDirection: "column", justifyContent: "center", alignContent: "center", alignItems: "center" }}>
                        <Card
                            title="Card Title"
                            content="This is some content inside the card. You can customize it."
                            buttonText="Click Me"
                            sx={{
                                backgroundColor: "#f4f5f9",
                                padding: "30px",
                                padding: "30px",
                                color: "#0A3575",
                                marginBottom: "0px !important",
                                // height: "70px",
                                width: "80%",
                                justifySelf: "center",
                                cursor: "pointer",
                                overflowX: 'auto', // Allow horizontal scrolling
                                whiteSpace: 'nowrap', // Prevent line breaks
                                 scrollbarWidth: 'none', // For Firefox
                            msOverflowStyle: 'none', // For Internet Explorer and Edge
                            '&::-webkit-scrollbar': {
                                display: 'none', // For Chrome, Safari, and Opera
                            },
                                ":hover": {
                                    backgroundColor: "#0A3575",
                                    color: "white",
                                    '& img': {
                                        filter: 'brightness(0) invert(1)' // Change image color to white

                                    },
                                },
                            }}
                            onClick={() => handleUserAccessNavigation()}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    cursor: "pointer",

                                }}
                            >
                                <img
                                    style={{ marginRight: "10px", marginTop: "-14px", transition: 'filter 0.3s' }}
                                    src={userLogo}
                                    alt="User Logo"
                                />
                                <Typography sx={{
                                    fontFamily: 'Montserrat',
                                    fontSize: '40px',
                                    fontWeight: 600,
                                    lineHeight: '60px',
                                    textAlign: 'left',
                                    color: "inherit", // Inherit color from parent Box
                                }}>
                                    User Access Management
                                </Typography>
                            </Box>
                        </Card>
                        {carouselMenuVisible && <CarouselMain />}
                    </Box>
                </Card>
            {/* </Box> */}

        </LayoutAccessManagement>
    )}
        </>
    );
};

export default RoleAssignHome;
